import axios from 'axios';
const token = 'FeMsA@2024';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Get clients within a polygon
export const getClientsInPolygon = async (polygonCoordinates) => {
  try {
    const response = await axios.post(
      `${API_URL}/polygon/clients`,
      { data: polygonCoordinates },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching clients in polygon:', error);
    throw error;
  }
};

// Get all clients
export const getClients = async (params = {}) => {
  try {
    const response = await axios.get(
      `${API_URL}/clients`,
      {
        headers: { 'Authorization': `Bearer ${token}` },
        params
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching clients:', error);
    throw error;
  }
};

// Get client by ID
export const getClientById = async (id) => {
  try {
    const response = await axios.get(
      `${API_URL}/clients/${id}`,
      {
        headers: { 'Authorization': `Bearer ${token}` }
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching client ${id}:`, error);
    throw error;
  }
};

// Update client
export const updateClient = async (id, clientData) => {
  try {
    const response = await axios.put(
      `${API_URL}/clients/${id}`,
      clientData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating client ${id}:`, error);
    throw error;
  }
};

// Update client status
export const updateClientStatus = async (id, status) => {
  try {
    const response = await axios.patch(
      `${API_URL}/clients/${id}/status`,
      { status },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating status for client ${id}:`, error);
    throw error;
  }
};

// Get client points
export const getClientPoints = async (clientId) => {
  try {
    const response = await axios.get(
      `${API_URL}/clients/points`,
      {
        headers: { 'Authorization': `Bearer ${token}` }
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching points for client ${clientId}:`, error);
    throw error;
  }
};

// Reconcile points
export const reconcilePoints = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/clients/points/reconciliation`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error reconciling points:', error);
    throw error;
  }
};
